export const getOffcanvasWidth = () => (window.innerWidth >= 768 ? '40vw' : '100vw');

export const getCurrentRoute = () => {
    const location = window.location.pathname;
    const routeName = location.split('/').filter(Boolean).pop();
    return routeName;
};